import React, {useEffect, useState} from 'react';
import {lang, langSiteDir} from '../../../common/baseData';
import Viewed from '../../../components/categoryPage/viewed/Viewed';

function EmptyBasket(props) {
  const [viewedProductList, setViewedProductList] = useState(null);

  useEffect(() => {
    if (
      viewedProductList !== null &&
      viewedProductList.hasOwnProperty('itemsList') &&
      Array.isArray(viewedProductList.itemsList) &&
      viewedProductList.itemsList.length
    ) {
      return;
    }

    let isMounted = true;
    const params = new URLSearchParams({
      lang,
      siteDir: langSiteDir,
      currentPath: window.location.pathname,
    });

    fetch(`/local/components/v2/viewed.product.list/ajax.php?${params.toString()}`,
      {credentials: 'same-origin'})
      .then(response => {
        if (!response.ok) {
          return null;
        }

        return response.json();
      })
      .then(data => {
        if (
          !isMounted ||
          data === null ||
          !data.hasOwnProperty('itemsList') ||
          !Array.isArray(data.itemsList) ||
          !data.itemsList.length
        ) {
          return;
        }

        setViewedProductList(data);
      })
      .catch(reason => console.error(reason));

    return () => {
      isMounted = false;
    };
  }, []);

  return (
      <div className="flex flex-col items-center">
        <div className="flex flex-col gap-[16px] items-center max-w-[280px]">
          <span className="text-[22px] font-semibold leading-normal text-center text-black">
            {props.getMessage('BASKET_EMPTY_TITLE')}
          </span>
          <span className="text-[16px] font-normal leading-normal text-center text-black">
            {props.getMessage('BASKET_EMPTY_TEXT')}
          </span>
          <a href={`${langSiteDir}recommend/`} className="w-[235px] h-[54px] flex items-center justify-center mt-[12px] py-[14px] px-[24px] rounded-[14px] bg-[#6364FF] text-[14px] font-medium leading-normal text-white">
            {props.getMessage('BASKET_EMPTY_BUTTON')}
          </a>
        </div>

        {
          viewedProductList !== null &&
          viewedProductList.hasOwnProperty('itemsList') &&
          Array.isArray(viewedProductList.itemsList) &&
          viewedProductList.itemsList.length && (
            <div className="w-full mt-[40px] desktop:mt-[80px] !pl-[25px] desktop:!pl-[30px] viewed-products viewed_products_js">
              <Viewed {...viewedProductList}
                      variant="basket"/>
            </div>
          )
        }
      </div>
  );
}

export default EmptyBasket;
